// extracted by mini-css-extract-plugin
export default {"p":"_7ec0ce2e50 _3aba732297 e209267e6e","clr":"_2c7975990d","dls":"b7d19e0054"};